import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';
import { ContentViewerComponent } from '../../../../shared/content-viewer/content-viewer.component';

@Component({
    // Distinct host attr so Ivy component-ID differs from the lesson copy
    // (same selector + same class shape → NG0912 after standalone migration).
    selector: 'app-multi-choice',
    host: { 'data-ms-scope': 'exercise' },
    templateUrl: './multi-choice.component.html',
    styleUrls: ['./multi-choice.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, ContentViewerComponent]
})
export class MultiChoiceComponent<T> implements OnInit {

  @Input() title: string;
  @Input() correctTitle: string;
  @Input() incorrectTitle: string;
  @Input() options: T[];
  @Input() discardedOptions: T[];
  @Input() text: T[];
  @Input() displayField: string;
  // In case we provide one identifier to select an option. (e.g the api return the right topic id, so the id used is 'id')
  @Input() idField: string;
  @Output() optionSelected: EventEmitter<T> = new EventEmitter();
  @Output() readyToContinue: EventEmitter<boolean> = new EventEmitter();

  correctOption: T;
  selectedOption: T;
  ansewered = false;

  constructor() {
  }

  ngOnInit() {
  }

  get moTitle() {
    if (!this.correctOption) {
      return this.title;
    } else if (this.getFieldIdentifier(this.selectedOption) === this.getFieldIdentifier(this.correctOption)) {
      return this.correctTitle;
    }
    return this.incorrectTitle;
  }

  selectOption(option: T) {
    this.selectedOption = option;
    this.optionSelected.emit(option);
  }

  getOptionClass(answer): string {
    if (answer === this.correctOption) {
      return 'btn-success';
    } else if (this.correctOption && answer === this.selectedOption) {
      return 'btn-danger';
    } else if (this.selectedOption) {
      return 'btn-outline-secondary';
    }
    return 'btn-primary';
  }

  setRightOption(option: number | T) {
    this.correctOption = this.getOptionById(option);
    this.readyToContinue.emit(true);
  }

  transformOption(option: T): string {
    return this.displayField ? option[this.displayField] : option as unknown as string;
  }

  reset() {
    this.correctOption = null;
    this.selectedOption = null;
  }

  isDiscardedOption(option: T): boolean {
    if (!this.discardedOptions) {
      return false;
    } else {
      const a = this.discardedOptions.find((opt) => option === opt);
      return a != null;
    }
  }

  /**
   * Case we are identifying option by id we should return option of type T (e.g Topic)
   * Case we receive the string of the right answer, we should return the string
   *
   * @param optionId
   * @returns
   */
  private getOptionById(optionId): T {
    return this.idField ? this.options.find(elem => elem[this.idField] === optionId) : optionId;
  }

  private getFieldIdentifier(object: T) {
    return this.idField ? object[this.idField] : object;
  }

}
